import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Box, Button, HStack, Select, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

type PaginationSquareProps = {
  offset: number;
  limit: number;
  total: number;
  setOffset: (newState: number) => void;
  setLimit: (newState: number) => void;
};

const MAX_ITEMS = 3;
const MAX_LEFT = (MAX_ITEMS - 1) / 2;

export const PaginationSquare = ({
  offset,
  limit,
  total,
  setOffset,
  setLimit
}: PaginationSquareProps) => {
  const [totalState, setTotalState] = useState(0);
  const [limitState, setLimitState] = useState(0);

  const currentPage = offset / limitState + 1;
  const totalPages = Math.ceil(totalState / limitState);
  const maxFirst = Math.max(totalPages - (MAX_ITEMS - 1), 1);
  const firstPage = Math.min(Math.max(currentPage - MAX_LEFT, 1), maxFirst);

  const handleOnPageChange = (page: any) => {
    setOffset((page - 1) * limitState);
  };

  useEffect(() => {
    setTotalState(total);
  }, [total]);

  useEffect(() => {
    setLimitState(limit);
  }, [limit]);

  return (
    <HStack w="100%" justifyContent="end" gridGap="10px">
      <Box w="50%" display="flex" justifyContent="start" alignItems="center">
        <Text
          fontWeight="400"
          fontSize="0.875rem"
          lineHeight="1.5rem"
          color="#5A5A5A"
        >
          Linhas por página
        </Text>
        <Select
          w="70px"
          color="#61596C"
          fontSize="0.875rem"
          value={limit}
          onChange={(e) => {
            handleOnPageChange(1);
            setLimit(Number(e.target.value));
          }}
          _hover={{}}
          _active={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
          border="none"
        >
          <option>05</option>
          <option>10</option>
          <option>20</option>
          <option>40</option>
        </Select>
      </Box>
      <Box
        w="50%"
        display="flex"
        justifyContent="end"
        alignItems="center"
        gridGap="10px"
      >
        <Box
          w="50%"
          display="flex"
          justifyContent="end"
          alignItems="center"
          gridGap="10px"
        >
          <Text
            m=" 0 38px 0 0 !important"
            fontWeight="400"
            fontSize="0.875rem"
            lineHeight="1.5rem"
            color="#5A5A5A"
          >
            Exibindo de {offset + 1} até{' '}
            {offset + limit > total ? total : offset + limit} de {total}
          </Text>
        </Box>
        <Button
          w="4.16px"
          h="6.99px"
          bg="transparent"
          m="0 !important"
          color="#323232"
          onClick={() => handleOnPageChange(currentPage - 1)}
          isDisabled={currentPage === 1 ? true : false}
          _hover={{}}
          _active={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
        >
          <ChevronLeftIcon />
        </Button>
        {Array.from({ length: Math.min(MAX_ITEMS, totalPages) }).map(
          (_, index) => {
            const page = index + firstPage;
            return (
              <Box
                key={index}
                w="32px"
                h="32px"
                p="6px 12px"
                bg={page === currentPage ? '#146CFA' : 'transparent'}
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="6px"
                color={page === currentPage ? '#FFFFFF' : '#323232'}
                onClick={() => handleOnPageChange(page)}
                cursor={'pointer'}
              >
                {page}
              </Box>
            );
          }
        )}
        <Button
          w="4.16px"
          h="6.99px"
          bg="transparent"
          m="0!important"
          color="#323232"
          onClick={() => handleOnPageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages ? true : false}
          _hover={{}}
          _active={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
        >
          <ChevronRightIcon />
        </Button>
      </Box>
    </HStack>
  );
};
